var tough_cookie_1 = require('tough-cookie');
function cookieJar(store) {
    return new tough_cookie_1.CookieJar(store);
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = cookieJar;
//# sourceMappingURL=jar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popsicle/dist/lib/jar.js
// module id = 52
// module chunks = 0 1